
// Initiate the element
// http://element.eleme.io
Vue.use(ELEMENT);

if(languageTag === 'da-DK'){
    ELEMENT.locale(ELEMENT.lang.da);
}else{
    ELEMENT.locale(ELEMENT.lang.en);
}

// Vue.use(ELEMENT);
Vue.use(VueChartJs);
// Vue.use(Chart);
// Initiate the app containing
// All routes an components
const app = new Vue({
	router: router,
	store: vuexStore,
});

// Initiate a communication gateway
// Between components, without any
// parent/child relationship
const bus = new Vue();

// Mount the app to html
// Container
app.$mount('#app');
